import CityPageTemplate from "../city-template/CityPageTemplate";
import { wyomingConfig } from "./data";

export default function WyomingPage() {
  return <CityPageTemplate config={wyomingConfig} />;
}